import React, { useRef, useState, useEffect } from "react";
import { FormGroup, FormControl, ControlLabel, ListGroupItem, ListGroup, Table } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import "./NewNote.css";
import { API } from "aws-amplify";
import Input from '../components/Input';
import { s3Upload } from "../libs/awsLib";
import { Storage } from "aws-amplify";
import { LinkContainer } from "react-router-bootstrap";
import CheckBox from '../components/CheckBox';  
import Button from '../components/Button';  
import Select from '../components/Select';

//factura_compra_files ,
//autorizacion_registrante_files
//comprobante_tgr_files, comprobante_deposito_files


export default function NewNote(props) {
  const toxicidadOptions = ['I-a Extremadamente Peligroso - Rojo','I-b Altamente Peligroso - Rojo','II Moderadamente Peligroso - Amarillo','III Ligeramente Peligroso - Azul','IV Precaución - Verde','1 Peligro - Rojo 0-5 DL','2 Peligro - Rojo 5.01-50 DL','3 Peligro - Amarillo 50.01 -300 DL','4 Azul 300.01- 2000 DL','5 Verde 2000.01-5000 DL o mas'];
  //const tipoUsoOptions = ['INSECTICIDA','INSECTICIDA-Larvicida','INSECTICIDA-Ovicida','INSECTICIDA-Aficida','INSECTICIDA-Piojicida','INSECTICIDA-Nematicida','INSECTICIDA-Acaricida','INSECTICIDA-Molusquicida','FUNGICIDA','HERBICIDA','FUMIGANTE','BIOCIDA','OTROS-Coadyuvantes','OTROS-Regulador de Ph','OTROS-Adherentes','OTROS-Surfactantes','OTROS-Vehículos físicos','OTROS-Sustancias afines','OTROS-Rodenticida','OTROS-Avicida','OTROS','FERTILIZANTE-Al suelo','FERTILIZANTE-Foliar','FERTILIZANTE-Enmienda']
  const tipoUsoOptions = ['BIOFERTILIZANTE','FERTILIZANTE','FERTILIZANTE Al Suelo','FERTILIZANTE Foliar','FERTILIZANTE Enmienda','FUMIGANTE','FUNGICIDA','HERBICIDA','INSECTICIDA','INSECTICIDA Aficida','INSECTICIDA Agricola','INSECTICIDA Acaricida','INSECTICIDA Bactericida','INSECTICIDA Botánico','INSECTICIDA Larvicida','INSECTICIDA Microbiológico','INSECTICIDA Molusquicida','INSECTICIDA Nematicida','INSECTICIDA Ovicida','INSECTICIDA Piojicida','OTROS Adherentes','OTROS Avicida','OTROS Bioestimulantes','OTROS Coadyuvantes','OTROS Regulador de Ph','OTROS Rodenticida uso agricola','OTROS Surfactantes','OTROS Sustancias afines','OTROS Vehículos físicos','OTROS'];
  const estatusItemOptions = ['REGISTRADO','AUTORIZADO','RECHAZADO'];
  const estatusDocumentoOptions = ['REGISTRADO','ENVIADO','CERRADO'];
  const puertos = ['Henecan','Puerto Cortes','Las Manos','El Amatillo','Villeda Morales','Toncontin','Guasaule','Agua Caliente','El Florido','Corinto','El Poy','Roatan','Puerto Castilla','La Fraternidad','Aeropuerto Goloson']
  const requisitosOptions = [ 'a. Debe Presentar la Etiqueta Armonizada','b. Para Uso Experimental','c. Para Uso Industrial','d. Para Uso en Salud Publica','e. Etiqueta En Español', 'f. Hoja de Seguridad'];

  const file = useRef(null);
  const file_factura = useRef(null);
  const file_autorizacion = useRef(null);
  const file_tgr = useRef(null);
  const file_deposito = useRef(null);
  
  const [usuario_registro, setUsuarioRegistro] = useState(props.email);
  const [puerto_entrada, setPuerto] = useState("");
  const [proveedor, setProveedor] = useState("");
  const [factura, setFactura] = useState("");
  const [fecha_embarque, setFechaEmbarque] = useState(null);
  const [productos, setProductos] = useState([]);
  const [id_solicitud,setIdSolicitud] = useState(null);
  const [id,setId] = useState(null);
  const [id_producto, setIDProducto] = useState(null);
  const [total_tgr, setTotal] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [certificado_registro_producto_files, setCertificadoFiles] = useState("");
  const [factura_compra_files, setFacturaCompraFiles] = useState("");
  const [autorizacion_registrante_files, setAutorizacionRegistranteFiles] = useState("");
  
  const [usr_autoriza,setUsrAutoriza] = useState("");
  const [nombre_autoriza,setNombreAutoriza] = useState("");
  
  const [files,setFiles] = useState([]);
  const [files_factura, setFilesFactura] = useState([]);
  const [files_autorizacion, setFilesAutorizacion] = useState([]);
  const [files_tgr, setFilesTGR] = useState([]);
  const [files_deposito, setFilesDeposito] = useState([]);
  
  const [files_borra,setFilesBorra] = useState([]);
  const [files_borra_factura, setFilesBorraFactura] = useState([]);
  const [files_borra_autorizacion, setFilesBorraAutorizacion] = useState([]);
  const [files_borra_tgr, setFilesBorraTGR] = useState([]);
  const [files_borra_deposito, setFilesBorraDeposito] = useState([]);
  
  const [temp_files,setTempFiles] = useState([]);
  const [temp_files_factura, setTempFilesFactura] = useState([]);
  const [temp_files_autorizacion, setTempFilesAutorizacion] = useState([]);
  const [temp_files_tgr, setTempFilesTGR] = useState([]);
  const [temp_files_deposito, setTempFilesDeposito] = useState([]);
  
  const [producto_comercial,setProductoComercial] = useState("");
  const [producto_generico,setProductoGenerico] = useState("");
  const [numero_registro,setNumeroRegistro] = useState("");
  const [recibo_pago, setReciboPago] = useState("");
  const [clasificacion_toxicologica, setClasificacion] = useState("");
  const [fecha_formulacion, setFechaFormulacion] = useState("");
  const [lote, setLote] = useState("");
  const [origen, setOrigen] = useState("");
  const [tipo_uso, setTipoUso] = useState("");
  const [tipo_uso_especifico, setTipoUsoEspecifico] = useState("");
  const [cantidad, setCantidad] = useState(null);
  const [presentacion, setPresentacion] = useState("");
  const [fabricante, setFabricante] = useState("");
  const [fob, setFOB] = useState(null); 
  const [monto_tgr, setMontoTGR] = useState(null);
  const [estatus, setEstatus] = useState("");
  const [razon_rechazo, setRazonRechazo] = useState("");
  const [showItem,setShowItem] = useState(false);
  const [editDelete,setEditDelete] = useState(false);
  const [isAdding,setIsAdding] = useState(true);
  
  const [initialFiles,setInitialFiles] = useState([]);
  const [initialFilesFactura, setInitialFilesFactura] = useState([]);
  const [initialFilesAutorizacion, setInitialFilesAutorizacion] = useState([]);
  const [initialFilesTGR, setInitialFilesTGR] = useState([]);
  const [initialFilesDeposito, setInitialFilesDeposito] = useState([]);
  
  const [usuario_solicita,setUsuarioSolicita] = useState("");
  
  const [fileURLs, setFileURLs] = useState([]);
  const [fileFacturaURLs, setFileFacturaURLs] = useState([]);
  const [fileAutorizacionURLs, setFileAutorizacionURLs] = useState([]);
  const [fileTGRURLs, setFileTGRURLs] = useState([]);
  const [fileDepositoURLs, setFileDepositoURLs] = useState([]);
  
  //Acceso a los archivos del registro para autorizadores
  const [fileCertificadoURLs, setCertificadoURLs] = useState([]);
  const [fileCarnetRegenteURLs, setCarnetRegenteURLs] = useState([]);
  const [fileArchivosAutorizacionURLs, setArchivosAutorizacionURLs] = useState([]);
  

  const [estatus_documento, setEstatusDocumento] = useState("REGISTRADO");
  const [requisitos,setRequisitos] = useState([]);
  
  const [label_certificado,setLabelCertificado] = useState("ADJUNTAR AQUI: Certificado de Registro de Producto Vigente (si se encuentra en proceso de renovación adjuntar copia de tracking)");
  const [label_factura,setLabelFactura] = useState("ADJUNTAR AQUI: Factura de Compra");
  const [label_autorizacion,setLabelAutorizacion] = useState("A continuacion debe adjuntar los archivos que acreditan la autorizacion del registrante");
  const [label_tgr, setLabelTGR] = useState("ADJUNTAR AQUI: Comprobante(s) de pago de TGR1 (favor adjunte todos los TGR1 que correspondan los productos incluidos en la solicitud)");
  const [label_deposito, setLabelDeposito] = useState("ADJUNTAR AQUI: Timbre o Comprobante de depósito a cuenta COLPROCAH / CINAH");
  
  useEffect(() => {
    function loadNote() {
      return API.get("notes", `/permisos/${props.match.params.id}`);
      return null;
    }

    async function onLoad() {
	 if (typeof props.match.params.id != 'undefined') {
		 setIsAdding(false);

		 setLabelCertificado("Adjuntos para certificado de registro de producto");
		 setLabelFactura("Adjuntos de la factura");
		 setLabelAutorizacion("Adjuntos que acreditan la autorización del registrante");
		 setLabelTGR("Adjuntos de pago por servicios TGR1");
		 setLabelDeposito("Adjuntos de comprobante de depósito a cuenta COLPROCAH / CINAH");
		 
		 try {
			 const note = await loadNote();
			 const { id , certificado_registro_files, fecha_embarque,	carnet_regente_files,	archivos_autorizacion, usuario_registro, fecha_registro, puerto_entrada,proveedor,factura, monto_factura,productos,total_tgr, certificado_registro_producto_files,factura_compra_files,autorizacion_registrante_files, comprobante_tgr_files, comprobante_deposito_files, estatus_documento, usuario_autoriza, fecha_autoriza, nombre_usuario_autoriza } = note.rows[0];
             setIdSolicitud(id);
			 setPuerto(puerto_entrada);
			 setProveedor(proveedor);
			 setFactura(factura);
			 setFechaEmbarque(fecha_embarque);
			 setUsuarioSolicita(usuario_registro);
			 setEstatusDocumento(estatus_documento);
			 setUsrAutoriza(usuario_autoriza);
			 setNombreAutoriza(nombre_usuario_autoriza);
			 
			 setFiles(JSON.parse(certificado_registro_producto_files));
			 setFilesFactura(JSON.parse(factura_compra_files));
			 setFilesAutorizacion(JSON.parse(autorizacion_registrante_files));
			 setFilesTGR(JSON.parse(comprobante_tgr_files));
			 setFilesDeposito(JSON.parse(comprobante_deposito_files));
			 
			 if (1==1) {
				 if (certificado_registro_files!=null) {
				 	var certificadoURLs = []
					 for (const file of JSON.parse(certificado_registro_files)) {
						 const attachmentURL = {file, url: (await Storage.vault.get(file,{ level: 'public'})) };
						 certificadoURLs = certificadoURLs.concat(attachmentURL);
					 }
					 setCertificadoURLs(certificadoURLs);
				 }
				 if (carnet_regente_files !=null) {
				 	var carnetRegenteURLs = []
					 for (const file of JSON.parse(carnet_regente_files)) {
						 const attachmentURL = {file, url: (await Storage.vault.get(file,{ level: 'public'})) };
						 carnetRegenteURLs = carnetRegenteURLs.concat(attachmentURL);
					 }
					 setCarnetRegenteURLs(carnetRegenteURLs);
				 }
				 if (archivos_autorizacion !=null) {
				 	var archivosAutorizacionURLs = []
					 for (const file of JSON.parse(archivos_autorizacion)) {
						 const attachmentURL = {file, url: (await Storage.vault.get(file,{ level: 'public'})) };
						 archivosAutorizacionURLs = archivosAutorizacionURLs.concat(attachmentURL);
					 }
					 setArchivosAutorizacionURLs(archivosAutorizacionURLs);
				 }	 
			 }
			 
			 if (certificado_registro_producto_files!=null) {
			 	setInitialFiles(JSON.parse(certificado_registro_producto_files));
   			    var URLs = []
   	   	        for (const file of JSON.parse(certificado_registro_producto_files)) {
   	   	        	const attachmentURL = {file, url: (await Storage.vault.get(file,{ level: 'public' }))};
   	   	        	URLs = URLs.concat(attachmentURL);
   	   	     	}
   			 	setFileURLs(URLs);
			 }
			 
			 if (factura_compra_files!=null) {
			 	setInitialFilesFactura(JSON.parse(factura_compra_files));
   			 	var FacturaURLs = []
   	   	     	for (const file of JSON.parse(factura_compra_files)) {
   	   	         	const attachmentURL = {file, url: (await Storage.vault.get(file,{ level: 'public' }))};
   	   	         	FacturaURLs = FacturaURLs.concat(attachmentURL);
   	   	     	}
   			 	setFileFacturaURLs(FacturaURLs);
			 }
			 
			 if (autorizacion_registrante_files!=null) {
			 	setInitialFilesAutorizacion(JSON.parse(autorizacion_registrante_files));
   			 	var AutorizacionURLs = []
   	   	     	for (const file of JSON.parse(autorizacion_registrante_files)) {
   	   	         	const attachmentURL = {file, url: (await Storage.vault.get(file,{ level: 'public' }))};
   	   	         	AutorizacionURLs = AutorizacionURLs.concat(attachmentURL);
   	   	     	}
   			 	setFileAutorizacionURLs(AutorizacionURLs);
			 }
			 
			 if (comprobante_tgr_files!=null) {
			 	setInitialFilesTGR(JSON.parse(comprobante_tgr_files));
   			 	var TGRURLs = []
   	   	     	for (const file of JSON.parse(comprobante_tgr_files)) {
   	   	         	const attachmentURL = {file, url: (await Storage.vault.get(file,{ level: 'public' }))};
   	   	         	TGRURLs = TGRURLs.concat(attachmentURL);
   	   	     	}
   			 	setFileTGRURLs(TGRURLs);
			 }
			 
			 if (comprobante_deposito_files!=null) {
			 	setInitialFilesDeposito(JSON.parse(comprobante_deposito_files));
   			 	var DepositoURLs = []
   	   	     	for (const file of JSON.parse(comprobante_deposito_files)) {
   	   	         	const attachmentURL = {file, url: (await Storage.vault.get(file,{ level: 'public' }))};
   	   	         	DepositoURLs = DepositoURLs.concat(attachmentURL);
   	   	     	}
   			 	setFileDepositoURLs(DepositoURLs);
			 }

			 //setRequisitos(requisitos!=null?JSON.parse(requisitos):[]); 
 			 setProductos(JSON.parse(productos));
		 } catch (e) {
			 alert(e);
		 }
 	 }
    }

    onLoad();
  }, [props.match.params.id]);
  
  
  function validateForm() {
    return true;
  }
  
  function esAutorizador() {
	  return !(usuario_solicita=="" || (usuario_registro==usuario_solicita));
  }
  
  async function handleRegresar(event) {
	  props.history.push("/");
  }
  
  function validateFile(file) {
	  if (file.size > config.MAX_ATTACHMENT_SIZE) {
	      alert(
	        `Por favor elija un archivo menor a ${
	          config.MAX_ATTACHMENT_SIZE / 1000000
	        } MB.`
	      );
	      return false;
	    }
		else {
			return true;
		}
  }
  
  function addFile(file) {
	  if (validateFile(file)) {
	  	setFiles(files.concat(file.name));
	  	setTempFiles(temp_files.concat(file));
	  } 
  }
  
  function addFileFactura(file) {
	  if (validateFile(file)) {
  	  	setFilesFactura(files_factura.concat(file.name));
	  	setTempFilesFactura(temp_files_factura.concat(file));
	  } 
  }
  
  function addFileAutorizacion(file) {
	  if (validateFile(file)) {
  	  	setFilesAutorizacion(files_autorizacion.concat(file.name));
	  	setTempFilesAutorizacion(temp_files_autorizacion.concat(file));
	  } 
  }
  
  function addFileTGR(file) {
	  if (validateFile(file)) {
  	  	setFilesTGR(files_tgr.concat(file.name));
	  	setTempFilesTGR(temp_files_tgr.concat(file));
	  } 
  }
  
  function addFileDeposito(file) {
	  if (validateFile(file)) {
  	  	setFilesDeposito(files_deposito.concat(file.name));
	  	setTempFilesDeposito(temp_files_deposito.concat(file));
	  } 
  }
  
  function doNothing() {
	  removeFile(files_borra);
  }
  
  function doNothingFactura() {
  	  removeFileFactura(files_borra_factura);
  }
  
  function doNothingAutorizacion() {
  	  removeFileAutorizacion(files_borra_autorizacion);
  }
  
  function doNothingTGR() {
  	  removeFileTGR(files_borra_tgr);
  }
  
  function doNothingDeposito() {
  	  removeFileDeposito(files_borra_deposito);
  }
  
  function removeFile(borra) {
	  setFiles(files.filter(item=>item!=borra));
	  setTempFiles(temp_files.filter(item=>item.name!=borra));
	  setFileURLs(fileURLs.filter(item=>item.file!=borra));
  }
  
  function removeFileFactura(borra) {
	  setFilesFactura(files_factura.filter(item=>item!=borra));
	  setTempFilesFactura(temp_files_factura.filter(item=>item.name!=borra));
	  setFileFacturaURLs(fileFacturaURLs.filter(item=>item.file!=borra));
  }
  
  function removeFileAutorizacion(borra) {
	  setFilesAutorizacion(files_autorizacion.filter(item=>item!=borra));
	  setTempFilesAutorizacion(temp_files_autorizacion.filter(item=>item.name!=borra));
	  setFileAutorizacionURLs(fileAutorizacionURLs.filter(item=>item.file!=borra));
  }
  
  function removeFileTGR(borra) {
	  setFilesTGR(files_tgr.filter(item=>item!=borra));
	  setTempFilesTGR(temp_files_tgr.filter(item=>item.name!=borra));
	  setFileTGRURLs(fileTGRURLs.filter(item=>item.file!=borra));
  }
  
  function removeFileDeposito(borra) {
	  setFilesDeposito(files_deposito.filter(item=>item!=borra));
	  setTempFilesDeposito(temp_files_deposito.filter(item=>item.name!=borra));
	  setFileDepositoURLs(fileDepositoURLs.filter(item=>item.file!=borra));
  }
  
  function handleFileChange(event) {
      file.current = event.target.files[0];
	  addFile(file.current);
    }
	
  function handleFileFacturaChange(event) {
      file_factura.current = event.target.files[0];
  	  addFileFactura(file_factura.current);
  }
	  
  function handleFileAutorizacionChange(event) {
	  file_autorizacion.current = event.target.files[0];
	  addFileAutorizacion(file_autorizacion.current);
   }
   
   function handleFileTGRChange(event) {
      file_tgr.current = event.target.files[0];
   	  addFileTGR(file_tgr.current);
   }
	  
   function handleFileDepositoChange(event) {
 	  file_deposito.current = event.target.files[0];
 	  addFileDeposito(file_deposito.current);
    }
   
	 
   function renderFiles(files) {
	   
		 return [].concat(files).map((file, i) =>
         (            
           <FormGroup>
            <FormControl.Static>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={file.url}
              >
                {file.file}
              </a>
            </FormControl.Static>
          </FormGroup>
         ) 
       );
     }

	 function getCommon(arr1, arr2) {
	   var common = [];                   
	   for(var i=0 ; i<arr1.length ; ++i) {
	     for(var j=0 ; j<arr2.length ; ++j) {
	       if(arr1[i] == arr2[j]) {       
	         common.push(arr1[i]);       
	       }
	     }
	   }
  
	   return common;                    
	 }
  

  async function handleSubmit(event,tipo) {
    event.preventDefault();
	
	if (usuario_registro.length == 0) {
		alert('Se ha perdido la sesión por favor haga logout y vuelva a ingresar');
		return;
	}
    
	var tipo_doc=estatus_documento;
	var usuario_reg=usuario_solicita==""?usuario_registro:usuario_solicita;
	
	if (tipo=='enviar') {
 	   const confirmed = window.confirm("Está seguro de enviar esta solicitud que incluye " + productos.length +  " productos para autorización?");
       if (!confirmed) {
            return;
	   } 
	   tipo_doc='ENVIADO';
	}
	
	if (tipo=='cerrar') {
		//if (requisitos==null || requisitos.length==0) {
		//	alert("Debe al menos seleccionar un requisito para poder cerrar esta solicitud");
		//	return;
		//}
		if (productos.filter(item=>item.estatus=='REGISTRADO').length>0) {
			alert("Existen productos que no han sido autorizados o rechazados, por favor revise");
			return;
		}	
 	   const confirmed = window.confirm("Está seguro de procesar esta solicitud y emitir el permiso?");
       if (!confirmed) {
            return;
	   } 
	   tipo_doc='CERRADO';
	}
	

    setIsLoading(true);
	
    try {
 	  var attachments = (!isAdding)?getCommon(initialFiles,files):[];
	  for (const file of temp_files) {
	      const attachment = await s3Upload(file);
	      attachments = attachments.concat(attachment);
	    }
	  var certificados = JSON.stringify(attachments);
	  
 	  var attachmentsFacturas = (!isAdding)?getCommon(initialFilesFactura,files_factura):[];
	  for (const file of temp_files_factura) {
	      const attachment = await s3Upload(file);
	      attachmentsFacturas = attachmentsFacturas.concat(attachment);
	    }
	  var facturas = JSON.stringify(attachmentsFacturas);
	  
 	  var attachmentsAutorizacion = (!isAdding)?getCommon(initialFilesAutorizacion,files_autorizacion):[];
	  for (const file of temp_files_autorizacion) {
	      const attachment = await s3Upload(file);
	      attachmentsAutorizacion = attachmentsAutorizacion.concat(attachment);
	    }
	  var autorizaciones = JSON.stringify(attachmentsAutorizacion);
	  
 	  var attachmentsTGR = (!isAdding)?getCommon(initialFilesTGR,files_tgr):[];
	  for (const file of temp_files_tgr) {
	      const attachment = await s3Upload(file);
	      attachmentsTGR = attachmentsTGR.concat(attachment);
	    }
	  var tgrs = JSON.stringify(attachmentsTGR);
	  
 	  var attachmentsDeposito = (!isAdding)?getCommon(initialFilesDeposito,files_deposito):[];
	  for (const file of temp_files_deposito) {
	      const attachment = await s3Upload(file);
	      attachmentsDeposito = attachmentsDeposito.concat(attachment);
	    }
	  var depositos = JSON.stringify(attachmentsDeposito);
	  
	  var reqs = JSON.stringify(requisitos);
	  if (isAdding) {
      	await createNote({ usuario_registro:usuario_reg, estatus_documento:tipo_doc, puerto_entrada, fecha_embarque, proveedor, factura, productos:JSON.stringify(productos), total_tgr, certificado_registro_producto_files:certificados, factura_compra_files:facturas ,autorizacion_registrante_files:autorizaciones, comprobante_deposito_files:depositos, comprobante_tgr_files:tgrs });
	  } else {
	  	await createNote({ usuario_registro:usuario_reg, estatus_documento:tipo_doc, puerto_entrada, fecha_embarque, proveedor, factura, productos:JSON.stringify(productos), total_tgr, certificado_registro_producto_files:certificados, factura_compra_files:facturas ,autorizacion_registrante_files:autorizaciones, comprobante_deposito_files:depositos, comprobante_tgr_files:tgrs, nombre_usuario_autoriza:nombre_autoriza, usuario_autoriza:usr_autoriza });
	  } 
      props.history.push("/");
    } catch (e) {
      alert('Error al guardar registro ' + e);
      setIsLoading(false);
    }
  }

  function createNote(note) {
	  
    return (isAdding)? API.post("notes", "/permisos", {
      body: note
    }) : API.put("notes","/permisos/" + props.match.params.id, {
	  body: note
    });
  }
  
  function agregarItem(event) {
	  event.preventDefault();
	  if (fob!=null && monto_tgr !=null && fob.length > 0 && monto_tgr.length > 0 && parseInt(fob) != NaN && parseInt(monto_tgr) != NaN && parseInt(fob)>0 && parseInt(monto_tgr)>0) {
	  const id = productos.length>0?productos[productos.length-1].id+1:1;
	  const producto = {id,estatus,producto_comercial,producto_generico,numero_registro,recibo_pago,clasificacion_toxicologica,fecha_formulacion,lote,origen,tipo_uso,cantidad,presentacion,fabricante,fob,monto_tgr,tipo_uso_especifico, razon_rechazo, requisitos};
	  setProductos(productos.concat(producto))
	  setShowItem(false);
  	  } else {
		  alert('Debe ingresar un valor tanto en TGR como en valor FOB, favor revise.');
  	  }
  }
  
  function editarItem(event) {
	  if (estatus=='RECHAZADO' && razon_rechazo.length==0) {
		  alert('Debe ingresar una razón del rechazo');
	  } else {
	  	  productos[id_producto-1] = {id,estatus,producto_comercial, producto_generico, numero_registro, recibo_pago,clasificacion_toxicologica, fecha_formulacion, lote ,origen, tipo_uso , cantidad , presentacion , fabricante , fob , monto_tgr, tipo_uso_especifico, razon_rechazo, requisitos };
  	  }
	  setEditDelete(false);
	  setShowItem(false);
	   
  }
  
  function deleteItem(event) {
  	  setProductos(productos.filter(item=>item.id!=id));
	  setEditDelete(false);
	  setShowItem(false);
  }
  
  function colapsarItem(event) {
  	  event.preventDefault();
	  setShowItem(false);
  }
  
  function renderNewItem (event) {
	  event.preventDefault();
	  setId(null);
	  setShowItem(true);
	  setProductoComercial("");
	  setProductoGenerico("");
	  setNumeroRegistro("");
	  setReciboPago("");
	  setClasificacion("");
	  setFechaFormulacion("");
	  setTipoUsoEspecifico("");
	  setLote("");
	  setOrigen("");
	  setTipoUso("");
	  setCantidad(null);
	  setPresentacion("");
	  setRequisitos([]);
	  setFabricante("");
	  setRazonRechazo("");
	  setEstatus("REGISTRADO");
	  setFOB(null);
	  setMontoTGR(null);
    }
	
	function selectItem(event,index) {
		event.preventDefault();
		setIDProducto(index);
		const producto = productos[index-1];
		setId(producto.id);
  	    setProductoComercial(producto.producto_comercial);
  	    setProductoGenerico(producto.producto_generico);
  	    setNumeroRegistro(producto.numero_registro);
  	    setReciboPago(producto.recibo_pago);
  	    setClasificacion(producto.clasificacion_toxicologica);
  	    setFechaFormulacion(producto.fecha_formulacion);
  	    setLote(producto.lote);
  	    setOrigen(producto.origen);
  	    setTipoUso(producto.tipo_uso);
		setTipoUsoEspecifico(producto.tipo_uso_especifico);
  	    setCantidad(producto.cantidad);
  	    setPresentacion(producto.presentacion);
  	    setFabricante(producto.fabricante);
  	    setFOB(producto.fob);
  	    setMontoTGR(producto.monto_tgr);
		setEstatus(producto.estatus);
		setRazonRechazo(producto.razon_rechazo);
		setRequisitos(producto.requisitos);
		setShowItem(true);
		setEditDelete(true);
	}
	
   function handleCheckBox(e) {
      const newSelection = e.target.value;
      let newSelectionArray;

      if(requisitos==null || requisitos.indexOf(newSelection) > -1) {
        newSelectionArray = requisitos.filter(s => s !== newSelection)
      } else {
        newSelectionArray = [...requisitos, newSelection];
      }
	  setRequisitos(newSelectionArray);
  }
  
  function handleTipoUso(e) {
  	  setTipoUso(e.target.value);
	  if (String(tipo_uso).includes('FERTILIZANTE')) {
	  	 setClasificacion("");
	  }
  }
  
  function renderRows(items) {
  	return [{}].concat(items).map((item,i) =>
		  i !== 0 ? (
		  	<tr>
			  <td>{i}</td>
			  <td><button onClick={e=>selectItem(e,i)}>Ver</button></td>
			  <td>{item.producto_comercial}</td>
			  <td>{item.producto_generico}</td>
			  <td>{item.numero_registro}</td>
			  <td>{item.tipo_uso}</td>
			  <td>{item.clasificacion_toxicologica}</td>
			  <td>{item.fob}</td>
			  <td>{item.monto_tgr}</td>
			  <td>{item.estatus}</td>
			</tr>  
		  ) : (null)
	  )
  }
  
  
  function renderItemsList(items) {
	  return (
<Table responsive>
  <thead>
    <tr>
      <th>#</th>
      <th>Sel</th>
      <th>Producto</th>
      <th>Generico</th>
      <th>Registro</th>
      <th>Tipo de Uso</th>
      <th>Toxicidad</th>
	  <th>FOB</th>
	  <th>Monto TGR</th>
	  <th>Estatus</th>
    </tr>
  </thead>
  <tbody>
	{renderRows(items)}
  </tbody>
</Table> 		
  	);
  }
  
  function renderItems() {
    return (
      <div className="notes">
        <ListGroup>
          {renderItemsList(productos)}
        </ListGroup>
      </div>
    );
}

function renderArchivosAutorizador() {
	return (
	<div>
  	  <ControlLabel>Adjuntos de la Copia de Certificado de Registro de Establecimiento Importador Vigente</ControlLabel>
     	<div>
	 		{renderFiles(fileCertificadoURLs)}
 	  	</div>
  	  <ControlLabel>Adjuntos de la Copia de Autorización de Registrante</ControlLabel>
     	<div>
	 		{renderFiles(fileArchivosAutorizacionURLs)}
 	    </div>
  	  <ControlLabel>Adjuntos de Copia de Carnet(s) de Regente(s) Vigente(s) </ControlLabel>
     	<div>
	 		{renderFiles(fileCarnetRegenteURLs)}
 	    </div>
	</div>
	);
}

  return (
    <div className="NewNote">
      <form>
	        <ControlLabel>{usuario_registro}</ControlLabel>
	  
      <Input inputType={'text'} 
       name={'id_solicitud'}
       title= {'ID Solicitud'} 
       value={id_solicitud} 
	   placeholder={'Este valor será llenado por el sistema una vez que el documento ha sido guardado o enviado'}
       disabled={true}
       handleChange={e=>setIdSolicitud(e.target.value)} />
	
	   {(esAutorizador() && renderArchivosAutorizador()) }
			 
		   <Select title={'Puerto de entrada'}
		           name={'puerto_entrada'}
		           options = {puertos} 
		           value = {puerto_entrada}
		           disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
				   placeholder={'Seleccione...'}
		           handleChange = {e=>setPuerto(e.target.value)}
		          /> 
			  
          <Input inputType={'text'} 
           name={'proveedor'}
           title= {'Nombre del proveedor'} 
           value={proveedor} 
		   disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
           placeholder = {'Ingrese nombre'}
           handleChange={e=>setProveedor(e.target.value)} /> 
		   
           <Input inputType={'text'} 
            name={'factura'}
            title= {'Nro. de factura del proveedor'} 
            value={factura} 
			disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
            placeholder = {'Ingrese numero de factura'}
            handleChange={e=>setFactura(e.target.value)} />
			
 		  <Input inputType={'date'}
 		 		   title= {'Fecha de Embarque'} 
 		    	   name= {'fecha_embarque'}
 		 		   value={fecha_embarque} 
				   disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
 				   placeholder = {'Ingrese fecha'}
 				   handleChange = {e=>setFechaEmbarque(e.target.value)}            
 				   />
			
            <Input inputType={'text'} 
             name={'usuario_solicita'}
             title= {'Usuario solicitud'} 
             value={usuario_solicita} 
			 placeholder={'Este valor será llenado por el sistema una vez que el documento ha sido guardado o enviado'}
             disabled={true}
             handleChange={e=>setUsuarioSolicita(e.target.value)} />
	
        <FormGroup controlId="file">
		  <ControlLabel>{label_certificado}</ControlLabel>
	      <div>
			 {renderFiles(fileURLs)}
	  	  </div>
		  <div> 
			 { (!esAutorizador() && estatus_documento=='REGISTRADO') ? (
			  <div>
              <FormControl onChange={handleFileChange} type="file"/>
              <CheckBox  title=''
                name={'files_borrar'}
                options={files}
                selectedOptions = {files_borra}
			    type="radio"
                handleChange={e=>setFilesBorra(e.target.value)}/>
              <LoaderButton
                block
                bsSize="small"
                bsStyle="danger"
                onClick={doNothing}
			    disabled={files.length==0}>
			    SI DESEA ELIMINAR ALGUNO DE LOS ARCHIVOS ADJUNTOS, SELECCIONE EL ARCHIVO Y LUEGO OPRIMA AQUÍ
              </LoaderButton>
			  </div>
			) : (null)
		    }
		</div>
        </FormGroup> 
		
    <FormGroup controlId="file_factura">
	  <ControlLabel>{label_factura}</ControlLabel>
      <div>
		 {renderFiles(fileFacturaURLs)}
  	  </div>
	  <div> 
		 { (!esAutorizador() && estatus_documento=='REGISTRADO') ? (
		  <div>
             <FormControl onChange={handleFileFacturaChange} type="file"/>
             <CheckBox  title=''
               name={'files_factura_borrar'}
               options={files_factura}
               selectedOptions = {files_borra_factura}
		    type="radio"
               handleChange={e=>setFilesBorraFactura(e.target.value)}/>
             <LoaderButton
               block
               bsSize="small"
               bsStyle="danger"
               onClick={doNothingFactura}
		    disabled={files_factura.length==0}>
		   SI DESEA ELIMINAR ALGUNO DE LOS ARCHIVOS ADJUNTOS, SELECCIONE EL ARCHIVO Y LUEGO OPRIMA AQUÍ
             </LoaderButton>
		  </div>
		) : (null)
	    }
	  </div>
     </FormGroup> 	
	
    <FormGroup controlId="file_tgr">
	  <ControlLabel>{label_tgr}</ControlLabel>
      <div>
		 {renderFiles(fileTGRURLs)}
  	  </div>
	  <div> 
		 { (!esAutorizador() && estatus_documento=='REGISTRADO') ? (
		  <div>
             <FormControl onChange={handleFileTGRChange} type="file"/>
             <CheckBox  title=''
               name={'files_tgr_borrar'}
               options={files_tgr}
               selectedOptions = {files_borra_tgr}
		    type="radio"
               handleChange={e=>setFilesBorraTGR(e.target.value)}/>
             <LoaderButton
               block
               bsSize="small"
               bsStyle="danger"
               onClick={doNothingTGR}
		    disabled={files_tgr.length==0}>
		    SI DESEA ELIMINAR ALGUNO DE LOS ARCHIVOS ADJUNTOS, SELECCIONE EL ARCHIVO Y LUEGO OPRIMA AQUÍ
             </LoaderButton>
		  </div>
		) : (null)
	    }
	  </div>
     </FormGroup> 	
		
<FormGroup controlId="file_deposito">
  <ControlLabel>{label_deposito}</ControlLabel>
     <div>
	 {renderFiles(fileDepositoURLs)}
 	  </div>
  <div> 
	 { (!esAutorizador() && estatus_documento=='REGISTRADO') ? (
	  <div>
            <FormControl onChange={handleFileDepositoChange} type="file"/>
            <CheckBox  title=''
              name={'files_deposito_borrar'}
              options={files_deposito}
              selectedOptions = {files_borra_deposito}
	    type="radio"
              handleChange={e=>setFilesBorraDeposito(e.target.value)}/>
            <LoaderButton
              block
              bsSize="small"
              bsStyle="danger"
              onClick={doNothingDeposito}
	    disabled={files_deposito.length==0}>
	    SI DESEA ELIMINAR ALGUNO DE LOS ARCHIVOS ADJUNTOS, SELECCIONE EL ARCHIVO Y LUEGO OPRIMA AQUÍ
            </LoaderButton>
	  </div>
	) : (null)
    }
  </div>
 </FormGroup> 	

		
		  <div className="Home">
			{renderItemsList(productos)}
		  </div>
			
			{
				(!esAutorizador() && estatus_documento=='REGISTRADO') ? (	
		  	  <div>
		  	  	<button className="open-modal-btn" onClick={e=>renderNewItem(e)} disabled={showItem || esAutorizador()}>Agregar producto</button>
          	  </div>
				) : (null)
			}
				
			
		  <div>
			{ showItem ? (
			  <div>
              <Input inputType={'text'}
                     title= {'Producto comercial'} 
                     name= {'producto_comercial'}
                     value={producto_comercial} 
					 disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
                     placeholder = {'Ingrese nombre del producto comercial'}
                     handleChange = {e=>setProductoComercial(e.target.value)}            
               />
	           <Input inputType={'text'}
	                        title= {'Producto Genérico (Fertilizantes: elementos y concentraciones / Plaguicida: Ingrediente activo y concentraciones)'} 
	                        name= {'producto_generico'}
	                        value={producto_generico} 
							disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
	                        placeholder = {'Ingrese nombre del producto genérico'}
	                        handleChange = {e=>setProductoGenerico(e.target.value)}            
	            />
			 	 <Input inputType={'text'}
			 	            title= {'Nro. de registro'} 
			 	            name= {'numero_registro'}
			 	            value={numero_registro} 
							disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
			 	            placeholder = {'Ingrese el # de registro del producto'}
			 	            handleChange = {e=>setNumeroRegistro(e.target.value)}            
			 	            />
		   	     <Input inputType={'text'}
				 			title= {'Fabricante o formulador'} 
		   			 	    name= {'fabricante'}
		   			 	    value={fabricante} 
							disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
		   			 	    placeholder = {'Ingrese el nombre del fabricante o formulador'}
		   			 	    handleChange = {e=>setFabricante(e.target.value)}            
		   			 	    />
		   		  <Input inputType={'text'}
		   				 	 title= {'Presentación del producto'} 
		   		   			 name= {'presentacion'}
		   		   			 value={presentacion} 
							 disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
		   		   			 placeholder = {'Ingreso texto'}
		   		   			 handleChange = {e=>setPresentacion(e.target.value)}            
		   		   			 />			 
		   		  <Input inputType={'text'}
		   		   			 title= {'Cantidad a Importar en (Lts. o Kgs.)'} 
		   		   		   	 name= {'cantidad'}
		   		   		   	 value={cantidad} 
							 disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
		   		   		   	 placeholder = {'Ingrese cantidad'}
		   		   		   	 handleChange = {e=>setCantidad(e.target.value)}            
		   		   		   	/>

				   <Select title={'Tipo de Uso'}
				                name={'tipo_uso'}
				                options = {tipoUsoOptions} 
				                value = {tipo_uso}
				                disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
								placeholder={'Seleccione...'}
				                handleChange = {e=>setTipoUso(e.target.value)}
				                /> 
					{ (tipo_uso=='OTROS') &&			
			 	      (<Input inputType={'text'}
			 		  		    title= {'Especificar Tipo de Uso (Si seleccionó Otros, porque no encontró el tipo adecuado en la lista)'} 
			 		  		    name= {'tipo_uso_especifico'}
			 		  		    value={tipo_uso_especifico} 
			 				    disabled={tipo_uso!='OTROS' || esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
			 		  		    placeholder = {'Ingrese texto'}
			 		  		   	handleChange = {e=>setTipoUsoEspecifico(e.target.value)}            
			 		  		    />)
							}
				   <Input inputType={'text'}
		  		   		   title= {'País de origen del producto'} 
		  		   		   name= {'origen'}
		  		   		   value={origen} 
						   disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
		  		   		   placeholder = {'Ingrese texto'}
		  		   		   handleChange = {e=>setOrigen(e.target.value)}            
		  		   		  />
				  <Input inputType={'text'}
				  		   title= {'Nro. de Lote'} 
				  		   name= {'lote'}
				  		   value={lote} 
						   disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
				  		   placeholder = {'Ingrese valor'}
				  		   handleChange = {e=>setLote(e.target.value)}            
				  		   />
		 		  <Input inputType={'date'}
		 		 		   title= {'Fecha de Formulación'} 
		 		    	   name= {'fecha_formulacion'}
		 		 		   value={fecha_formulacion} 
						   disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
		 				   placeholder = {'Ingrese fecha'}
		 				   handleChange = {e=>setFechaFormulacion(e.target.value)}            
		 				   />
		 		 <Input inputType={'text'}
		 		 		   title= {'Valor FOB'} 
		 		    	   name= {'fob'}
		 		 		   value={fob} 
						   disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
		 		 		   placeholder = {'Ingrese monto'}
		 		 		   handleChange = {e=>setFOB(e.target.value)}            
		 		     	   />
						   
				{ (!String(tipo_uso).includes('FERTILIZANTE')) && (
				<Select title={'Clasificacion Toxicológica'}
				            name={'clasificacion_toxicologica'}
					        options = {toxicidadOptions} 
					        value = {clasificacion_toxicologica}
					        disabled={false}
							disabled={String(tipo_uso).includes('FERTILIZANTE') || esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
							placeholder={'Seleccione...'}
					        handleChange = {e=>setClasificacion(e.target.value)}
						       /> )
				}						
		  		 <Input inputType={'text'}
		  		  		   title= {'Nro. de Correlativo recibo de pago/TGR'} 
		  		     	   name= {'recibo_pago'}
		  		  		   value={recibo_pago} 
						   disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
		  		  		   placeholder = {'Ingrese #'}
		  		  		   handleChange = {e=>setReciboPago(e.target.value)}            
		  		      	   />
		  		 <Input inputType={'text'}
		  		  		   title= {'Monto TGR'} 
		  		     	   name= {'monto_tgr'}
		  		   		   value={monto_tgr} 
						   disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}
		  		   		   placeholder = {'Ingrese monto en Lempiras'}
		  		   		   handleChange = {e=>setMontoTGR(e.target.value)}            
		  		       	   />
						   
		   		<Select title={'Estatus'}
		   				    name={'estatus'}
		   			        options = {estatusItemOptions} 
		   			        value = {estatus}
		   			        disabled={!esAutorizador() || estatus_documento=='CERRADO'}
		   					placeholder={'Seleccione...'}
		   			        handleChange = {e=>setEstatus(e.target.value)}
		   			       /> 
				{ (estatus=='RECHAZADO') && (		
		   		<Input inputType={'text'}
		   			   title= {'Por Favor explique la razón del rechazo'} 
		   	     	   name= {'razon_rechazo'}
		   	   		   value={razon_rechazo} 
		   			   disabled={!esAutorizador() || estatus_documento=='CERRADO'}
		   	   		   placeholder = {'Ingrese texto'}
		   	   		   handleChange = {e=>setRazonRechazo(e.target.value)}            
		   		  	   />
				  )			
				}
				
		   	 { (esAutorizador()) ? (
		   	   <CheckBox  title='Para uso interno del departamento'
		   	     name={'requisitos'}
		   	     options={requisitosOptions}
		         selectedOptions = {requisitos}
		   		 disabled={!esAutorizador() || estatus_documento=='CERRADO' }
		     		 type="checkbox"
		   	     handleChange={handleCheckBox}/>
		   	    ) : (
		   	    	null
		   	    )
		   	 }	
				
				<div>
					{ (!editDelete) ? (
					   <div>
					   <button className="open-modal-btn" onClick={e=>agregarItem(e)} disabled={esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}>Confirmar Registro</button>
					   <button className="open-modal-btn" onClick={e=>colapsarItem(e)}>Regresar</button> 
					   </div>
					)
					  : ((esAutorizador()) ? (
					   	<div>
			           		<button className="open-modal-btn" onClick={e=>editarItem(e)} disabled={!editDelete || estatus_documento=='CERRADO'}>Actualizar Estatus</button>
					   		<button className="open-modal-btn" onClick={e=>colapsarItem(e)}>Regresar</button> 
					   	</div>
						) : (
					   	<div>
			           		<button className="open-modal-btn" onClick={e=>editarItem(e)} disabled={!editDelete || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}>Modificar</button>
				       		<button className="open-modal-btn" onClick={e=>deleteItem(e)} disabled={!editDelete || esAutorizador() || estatus_documento=='CERRADO' || estatus_documento=='ENVIADO'}>Eliminar</button>
					   		<button className="open-modal-btn" onClick={e=>colapsarItem(e)}>Regresar</button> 
					   	</div>
						) 
					  )		
					}
				</div>   
			    
				
			    			   		

				</div>
		      ) : (null)
		    }
		  </div>	
			
	 <Select title={'Estatus'}
	   		name={'estatus'}
	  	        options = {estatusDocumentoOptions} 
	  	        value = {estatus_documento}
	  	        disabled={true}
	     		placeholder={'Seleccione...'}
	            handleChange = {e=>setEstatusDocumento(e.target.value)}
	       /> 
				
	
	 { (estatus_documento=='CERRADO' || (!esAutorizador() && estatus_documento=='ENVIADO')) ? (null)
	  :(	  	
       <LoaderButton
          block
          bsSize="large"
          bsStyle="primary"
			onClick={e=>handleSubmit(e,'guardar')}
          isLoading={isLoading}
          disabled={!validateForm()}
        >
          Guardar Solicitud (para ser completada posteriormente)
        </LoaderButton>
		  
	  )
  }
		  { (!esAutorizador() && estatus_documento=='REGISTRADO') ? (
        <LoaderButton
            block
            bsSize="large"
            bsStyle="warning"
		    onClick={e=>handleSubmit(e,'enviar')}
            isLoading={isLoading}
            disabled={esAutorizador() || productos.length==0}
        >
            Confirmar y Enviar Solicitud (al Senasa para su aprobación)
        </LoaderButton>
		) : (esAutorizador() && estatus_documento=='ENVIADO' &&(
        <LoaderButton
            block
            bsSize="large"
            bsStyle="success"
		    onClick={e=>handleSubmit(e,'cerrar')}
            isLoading={isLoading}
            disabled={isAdding}
        >
            Procesar solicitud y emitir permiso
        </LoaderButton>
		))
		   }
		   { (estatus_documento=="CERRADO") ? 
		   ( (productos.filter(item=>item.estatus=='AUTORIZADO').length > 0) ? (
 			  		<div className="div-uno">
			   			<FormGroup>
  			 				<FormControl.Static>
   								<a
      		 						target="_blank"
     		  						rel="noopener noreferrer"
      		 						href={"https://dte-gestiomas.s3-us-west-2.amazonaws.com/senasa/" + props.match.params.id + ".pdf"}
    							>
      							{"Descargar Permiso"}
    							</a>
  							 </FormControl.Static>
						</FormGroup>
				 </div> 
				) : (
				  <div className="div-uno">
					<ControlLabel>ESTA SOLICITUD HA SIDO RECHAZADA, REVISE LOS DETALLES DE RECHAZO EN LOS PRODUCTOS</ControlLabel>
				  </div>	
				) 
			) 
		: (null)
		
}   
     <LoaderButton
        block
        bsSize="large"
        bsStyle="danger"
		onClick={handleRegresar}
        isLoading={isLoading}
        disabled={!validateForm()}
      >
        Regresar
      </LoaderButton>
      </form>
    </div>
  );
}
